var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCycleYellow = function SvgCycleYellow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEE565",
    fillRule: "evenodd",
    d: "M28.007 0l-2.822 3.961 1.074.653c5.549 3.373 8.732 8.44 8.732 13.9 0 5.477-3.167 10.543-8.69 13.902l-1.058.643 2.752 3.978.936-.567C33.981 33.41 40 27.81 40 18.515 40 9.219 33.982 3.62 28.931.559L28.007 0zm-14.27 4.614c-5.547 3.373-8.729 8.44-8.729 13.9 0 5.477 3.166 10.543 8.688 13.902l1.06.643-2.753 3.978-.935-.567C6.02 33.41 0 27.811 0 18.515 0 9.219 6.018 3.62 11.067.559L11.99 0l2.821 3.961-1.074.653z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCycleYellow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cycle-yellow.8209ee8d.svg";
export { ForwardRef as ReactComponent };